if (!customElements.get('jupityr-footer-menus')) {
  customElements.define('jupityr-footer-menus', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const desktop = window.matchMedia('(min-width: 750px)');
      const menus = [...this.querySelectorAll('.jupityr-footer__menu')];
      const sync = () => menus.forEach(menu => {
        menu.open = desktop.matches;
        menu.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
      });
      sync();
      desktop.addEventListener('change', sync, { signal });
      this.addEventListener('click', event => {
        if (desktop.matches && event.target.closest('summary')) event.preventDefault();
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const menu = event.target.closest('.jupityr-footer__menu') || event.target.querySelector('.jupityr-footer__menu');
        if (menu) menu.open = true;
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
